/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 1
// module chunks = main